import React from "react";
import dayjs from "dayjs";

import { useRecoilValueLoadable, useSetRecoilState } from "recoil";
import { asyncGetCategoryRequestList } from "lib/store/project";
import { modalState } from "lib/store/common";

import "./RequestList.scss";

export type RequestListProps = {
  cx?: string;
};

export const RequestList: React.FC<RequestListProps> = ({ cx = "" }) => {
  const setModal = useSetRecoilState(modalState);
  const { state, contents } = useRecoilValueLoadable(
    asyncGetCategoryRequestList
  );
  return (
    <div className={`RequestList ${cx}`}>
      <table>
        <thead>
          <tr>
            <td>카테고리명</td>
            <td>상태</td>
            <td>요청 날짜</td>
          </tr>
        </thead>
        <tbody>
          {state === "hasValue" &&
            contents.results.map(
              (i: { name: string; result: string; created_at: string }) => (
                <tr key={`${i.created_at}`}>
                  <td>{i.name}</td>
                  <td>
                    {!!i.result ? (
                      <span className={"blue"}>딥변완료</span>
                    ) : (
                      "대기중"
                    )}
                  </td>
                  <td>{dayjs(i.created_at).format("YYYY.MM.DD")}</td>
                </tr>
              )
            )}
        </tbody>
      </table>
      <div className="button-wrapper">
        <span
          className={"small"}
          onClick={() =>
            setModal((_) => ({
              ..._,
              requestCategory: false,
              categorySelect: true,
            }))
          }
        >
          ← 카테고리 선택창으로 돌아가기
        </span>
      </div>
    </div>
  );
};
